import { render, staticRenderFns } from "./DataSorter.vue?vue&type=template&id=86122f70"
import script from "./DataSorter.vue?vue&type=script&lang=js"
export * from "./DataSorter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports